import { render, staticRenderFns } from "./footerApp.vue?vue&type=template&id=44a56983&lang=pug"
import script from "./footerApp.vue?vue&type=script&lang=js"
export * from "./footerApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports